const prefix = '[settings]';

export const GET_SETTINGS = `${prefix} GET_SETTINGS`;
export const SAVE_SETTINGS = `${prefix} SAVE_SETTINGS`;



// WEBPACK FOOTER //
// ./src/app/components/settings/__store__/constants.js